<div
  class="modal bg-black/50 flex items-center justify-center overflow-hidden clickClose p-2"
  style="z-index: 999; position: fixed"
  (click)="this.close($event)"
  #container>
  <div #fadeInContainer
    (animationend)="this.removeFadeInFromContainer()"
    class="relative bg-white w-full max-w-[500px] h-max rounded flex flex-col fadeIn overflow-hidden overflow-y-auto text-black">
    @if (this.paymentsWays.length > 0) {
      <div class="w-full flex items-center p-3 gap-2 mb-2 border-bottom-1 border-gris-3">
        <div class="text-white flex items-center justify-center rounded w-8 h-8 fg-vert-1 bg-vert-3">
          <span class="material-icons">
            wallet
          </span>
        </div>
        <p class="text-md font-semibold fg-noir-2">Rechargement du portefeuille</p>
      </div>
    }
    @if (this.paymentsWays.length > 0) {
      <mk-text-input (keydown.enter)="this.clickOnPay()"
        [placeholder]="'Montant de la recharge (Min. ' + this.minWallet + '€)' " classes="text-sm"
        textAlign="left" (keyup)="this.updateText($event)" type="text" class="w-3/4 mx-auto mb-4 border-none"
        id="reload-wallet-input"
        autofocus
        />
    }
    @if (this.paymentsWays.length > 0) {
      <div class="w-full flex flex-col items-center gap-2 justify-center mb-4">
        @for (way of this.paymentsWays; track way) {
          <div
            (click)="this.togglePaymentWay(way)"
            class="group border border-gris-3 rounded p-2 flex justify-center gap-2 fg-gris-2 font-medium w-64 mx-auto cursor-pointer h-16 my-0"
            [class.fg-vert-1]="this.isPaymentSelected(way)"
            [class.font-semibold]="this.isPaymentSelected(way)"
            [class.border-vert-1]="this.isPaymentSelected(way)"
            >
            <div
              class="group-hover:grayscale-0 grayscale my-auto"
              [class.grayscale]="!this.isPaymentSelected(way)"
              [innerHTML]="this.computeIconHtml(way)"
            ></div>
            <p class="h-fit my-auto text-center" [innerText]="this.formatWay(way)"></p>
          </div>
        }
      </div>
    }
    @if (this.paymentsWays.length > 0) {
      <mk-green-action-button #payBtn baseIcon="payments"
        [enabled]="true"
        [data]="this"
        [callback]="this.reloadWallet"
        [_state]="this.selectedPaymentWay ? 'default' : 'failed'"
        [baseLabel]="this.selectedPaymentWay ? 'Passer au paiement' : 'Choisissez un moyen de paiement'"
        class="w-3/4 h-8 mx-auto mb-4"
        />
    }
  </div>
</div>
